export default __webpack_public_path__ + "static/media/bg.cbdef683.png";